import { Injectable } from '@angular/core';
import * as PptxGenJS from 'pptxgenjs-angular'
import { DatePipe } from '@angular/common';
import { ObraDTO } from 'src/app/models/dtos/obra-dto';
import html2canvas from 'html2canvas';
import { LoaderService } from '../../services/loader.service';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { RutaCatalogoEnum } from '../enums/ruta-catalogo.enum';
import { take } from 'rxjs/operators';
import { CatalogoService } from 'src/app/services/catalogo.service';

@Injectable({
    providedIn: 'root'
})
export class PptxUtils {

    public mapaFichaTecnicaBase64: any;
    public validacionUCL: any;
    public mapaNotaInformaticaBase64: any;
    public catCorredores: ElementoCatalogo[] = [];
    public nombreCorredor: string;

    public titulosFichaTecnica: any = {
        descripcion: 'Caracteristicas de la obra:',
        TDPA: 'TDPA (Veh/día):',
        Tipodecarpetayseccion: 'Tipo de carpeta y sección:',
        periodoEjecucion: 'PERIODO DE EJECUCIÓN:',
        longitudTotal: 'LONGITUD TOTAL:',
        inversionTotal: 'INVERSIÓN TOTAL:',
        esquemaFinanciamiento: 'ESQUEMA DE FINANCIAMIENTO:',
        tituloSituacionObra: 'SITUACIÓN ACTUAL DE LA OBRA',
        SHCP: 'Registro SHCP:',
        estatusSHCP: 'Estatus de registra SHCP:',
        proyectoEjecutivo: 'Proyecto ejecutivo:',
        derechoVia: 'Liberación del Derecho de Vía:',
        usoSuelo: 'Cambio de Uso de Suelo:',
        IA: 'Manifestación de IA:',
        avanceFisico: 'Avance físico:',
        avanceFinanciero: 'Acance financiero:',
        avanceFisicoGlobal: 'Avance físico global:',
        avanceFinancieroGlobal: 'Acance financiero global:',
        observaciones: 'Observaciones:',
        problematica: 'Problemática',
        fecha: 'Fecha de actualización: 02 de Septiembre de 2019',
        beneficios: 'Beneficios:',
        acciones: 'Próximas acciones:',
        corredor: 'Corredor'
    };

    public titulosNotaInformativa: any = {
        titulo: 'NOTA INFORMATIVA',
        tituloMapa: 'CROQUIS DE UBICACIÓN',
        asunto: 'Asunto:',
        descripcion: 'Descripción:',
        costoTotal: 'Costo total:',
        metaTotal: 'Meta total:',
        TDPA: 'TDPA:',
        registro: 'Registro:',
        proyecto: 'Proyecto:',
        derechoVia: 'Derecho de Vía:',
        MIA: 'MIA:',
        CUS: 'CUS:',
        avances: 'Avances:',
        avanceFisicoGlobal: 'Físico Global de:',
        avanceFinancieroGlobal: 'Financiero Global de:',
        problematica: 'Problemática:',
        acciones: 'Próximas acciones:',
        situacion: 'Situación física - financiera:'
    };

    constructor(public datepipe: DatePipe,
        private loaderScreenService: LoaderService,
        private catalogoService: CatalogoService) {
    }

    public async descargarPowerPointFichaTecnica(obraSeleccionada: ObraDTO) {
        this.catCorredores = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CORREDORES).pipe(take(1)).toPromise();
        if (obraSeleccionada.obra.keyCatCorredor) {
            this.nombreCorredor = this.catCorredores.find((corredor: ElementoCatalogo) => corredor.key === obraSeleccionada.obra.keyCatCorredor).nombre;
        } else {
            this.nombreCorredor = 'Sin Corredor';
        }
        this.obtenerBase64ImageFichaTecnica().then(
            () => {
                this.generarPowerPointFichaTecnica(obraSeleccionada);
            }
        );
    }

    public async obtenerBase64ImageFichaTecnica(): Promise<any> {
        this.loaderScreenService.activarLoaderScreen();
        let configuracionCanvas = {
            // Opciones
            allowTaint: true,
            useCORS: true,
            // Calidad del PDF
            scale: 5,
            ignoreElements: function (element) {
                return element.classList.contains('gm-style-mtc') ? true : false;
            }
        };
        return new Promise((resolve, reject) => {
            html2canvas(document.getElementById('contenedor-mapa'), configuracionCanvas)
                .then(mapaFichaTecnica => {
                    let imgMapa = mapaFichaTecnica.toDataURL('image/jpeg', 1.0);
                    this.mapaFichaTecnicaBase64 = imgMapa;
                    this.loaderScreenService.desactivarLoaderScreen();
                    resolve();
                    // return html2canvas(document.getElementById('contendor-ucl'), configuracionCanvas);
                })
                // .then(validacionUCL => {
                //     let imgValidacionUCL = validacionUCL.toDataURL('image/jpeg', 1.0);
                //     this.validacionUCL = imgValidacionUCL;
                //     this.loaderScreenService.desactivarLoaderScreen();
                //     resolve();
                // })
                .catch(error => {
                    console.error("Error al generar pdf: ", error);
                    reject();
                });
        });
    }

    public generarPowerPointFichaTecnica(obraSeleccionada: ObraDTO) {
        var pptx = new PptxGenJS();
        const carpetas = ["Asfáltica", "Hidráulica", "Rodaderas"];
        const secciones = ["A1", "A2", "A3", "A4", "6M", "7M", "9M", "C2", "C4", "D"];

        var slide = pptx.addNewSlide();
        // HEADER
        slide.addImage({ path: '../../../../../assets/img/header.JPG', x: 0, y: 0, w: 9.1377953, h: 0.3464567 });
        slide.addText(obraSeleccionada.nombreObra, { x: 0, y: 0, w: '100%', h: 0.2, fontSize: 7, align: 'l', color: 'ffffff', bold: true });
        slide.addText(obraSeleccionada.nombreEstado, { x: 0, y: 0.1456693, w: '100%', h: 0.2, fontSize: 7, align: 'l', color: 'ffffff', bold: true });
        slide.addText(this.titulosFichaTecnica.descripcion, { x: 0, y: 0.3700787, w: 6.0826772, h: 0.14173228, fontSize: 5, align: 'l', color: '000000', bold: true });
        slide.addText(obraSeleccionada.obra.caracteristicas, { x: 0, y: 0.4448819, w: 6.0826772, h: 0.4370079, fontSize: 5, align: 'l', color: '000000', autoFit: true, valign: 'top' });
        //END HEADER

        // COL LEFT
        var rows = [];
        rows.push([
            { text: this.titulosFichaTecnica.TDPA, options: { color: '000000', bold: true, align: 'r' } },
            { text: obraSeleccionada.obra.tpda, options: { color: '000000', align: 'l' } }
        ]);
        rows.push([
            { text: this.titulosFichaTecnica.corredor, options: { color: '000000', bold: true, align: 'r' } },
            { text: this.nombreCorredor, options: { color: '000000', align: 'l' } }
        ]);
        rows.push([
            { text: this.titulosFichaTecnica.Tipodecarpetayseccion, options: { color: '000000', bold: true, align: 'r' } },
            { text: carpetas[obraSeleccionada.obra.keyCatCarpeta] + ' - ' + secciones[obraSeleccionada.obra.keyCatSeccion], options: { color: '000000', align: 'l' } }
        ]);
        slide.addTable(rows, { x: 0.1889764, y: 0.6889764, w: 5.8937008, h: 0.3661417, color: 'ffffff', fontSize: 5, border: { pt: '0', color: 'ffffff' } });

        var rows2 = [];
        rows2.push([
            { text: this.titulosFichaTecnica.periodoEjecucion, options: { color: '000000', bold: true, align: 'r' } },
            { text: obraSeleccionada.obra.periodoEjecucion, options: { color: '000000', bold: true, align: 'l' } }
        ]);
        rows2.push([
            { text: this.titulosFichaTecnica.longitudTotal, options: { color: '000000', bold: true, align: 'r' } },
            { text: obraSeleccionada.obra.longitudTotal + ' KM', options: { color: '000000', bold: true, align: 'l' } }
        ]);
        rows2.push([
            { text: this.titulosFichaTecnica.inversionTotal, options: { color: '000000', bold: true, align: 'r' } },
            { text: obraSeleccionada.obra.inversionTotal + ' MDP', options: { color: '000000', bold: true, align: 'l' } }
        ]);
        rows2.push([
            { text: this.titulosFichaTecnica.esquemaFinanciamiento, options: { color: '000000', bold: true, align: 'r' } },
            { text: obraSeleccionada.obra.esquemaFinanciamiento, options: { color: '000000', bold: true, align: 'l' } }
        ]);
        slide.addTable(rows2, { x: 0.1889764, y: 1.153543, w: 5.8937008, h: 0.7322835, fill: 'D9D9D9', fontSize: 6, border: { pt: '1', color: 'ffffff' } });

        var rows3 = [];
        rows3.push([
            { text: 'EJERCICIO FISCAL', options: { color: '000000', bold: true, align: 'c', fill: 'D9D9D9' } },
            { text: 'ASIGNACIÓN (mdp)', options: { color: '000000', bold: true, align: 'c', fill: 'D9D9D9' } },
            { text: 'META (km - estructura)', options: { color: '000000', bold: true, align: 'c', fill: 'D9D9D9' } }
        ]);
        var someArray = obraSeleccionada.obra.ejerciciosFiscales;
        for (var item of someArray) {
            rows3.push([
                { text: item.esquemaFiscal, options: { color: '000000', align: 'c' } },
                { text: item.asignacion, options: { color: '000000', align: 'c' } },
                { text: item.meta, options: { color: '000000', align: 'c' } }
            ]);
        }
        slide.addTable(rows3, { x: 0.1889764, y: 1.944882, w: 5.8937008, h: 0.9173228, fontSize: 6, border: { pt: '1', color: 'bfbfbf' } });

        var rows4 = [];
        rows4.push([
            { text: this.titulosFichaTecnica.tituloSituacionObra, options: { color: '000000', bold: true, align: 'c' } }
        ]);
        slide.addTable(rows4, { x: 0.1732283, y: 2.937008, w: 5.9094488, h: 0.1850394, fontSize: 6, fill: 'D9D9D9', border: { pt: '1', color: 'bfbfbf' } });

        var rows5 = [];
        rows5.push([
            { text: this.titulosFichaTecnica.SHCP, options: { color: '000000', bold: true, align: 'l' } },
            { text: obraSeleccionada.obra.registroSHCP, options: { color: '000000', align: 'l' } }
        ]);
        rows5.push([
            { text: this.titulosFichaTecnica.estatusSHCP, options: { color: '000000', bold: true, align: 'l' } },
            { text: obraSeleccionada.obra.estatusSHCP, options: { color: '000000', align: 'l' } }
        ]);
        rows5.push([
            { text: this.titulosFichaTecnica.proyectoEjecutivo, options: { color: '000000', bold: true, align: 'l' } },
            { text: obraSeleccionada.obra.proyectoEjecutivo + ' %', options: { color: '000000', align: 'l' } }
        ]);
        rows5.push([
            { text: this.titulosFichaTecnica.derechoVia, options: { color: '000000', bold: true, align: 'l' } },
            { text: obraSeleccionada.obra.liberacionDerechoVia + ' %', options: { color: '000000', align: 'l' } }
        ]);
        rows5.push([
            { text: this.titulosFichaTecnica.usoSuelo, options: { color: '000000', bold: true, align: 'l' } },
            { text: obraSeleccionada.obra.cus + ' %', options: { color: '000000', align: 'l' } }
        ]);
        rows5.push([
            { text: this.titulosFichaTecnica.IA, options: { color: '000000', bold: true, align: 'l' } },
            { text: obraSeleccionada.obra.mia + ' %', options: { color: '000000', align: 'l' } }
        ]);
        if (obraSeleccionada.obra.avanceFisico) {
            rows5.push([
                { text: this.titulosFichaTecnica.avanceFisico, options: { color: '000000', bold: true, align: 'l' } },
                { text: obraSeleccionada.obra.avanceFisico + ' %', options: { color: '000000', align: 'l' } }
            ]);
        }
        if (obraSeleccionada.obra.avanceFinanciero) {
            rows5.push([
                { text: this.titulosFichaTecnica.avanceFinanciero, options: { color: '000000', bold: true, align: 'l' } },
                { text: obraSeleccionada.obra.avanceFinanciero + ' MDP', options: { color: '000000', align: 'l' } }
            ]);
        }
        rows5.push([
            { text: this.titulosFichaTecnica.avanceFisicoGlobal, options: { color: '000000', bold: true, align: 'l' } },
            { text: obraSeleccionada.obra.avanceFisicoGlobal + ' %', options: { color: '000000', align: 'l' } }
        ]);
        rows5.push([
            { text: this.titulosFichaTecnica.avanceFinancieroGlobal, options: { color: '000000', bold: true, align: 'l' } },
            { text: obraSeleccionada.obra.avanceFinancieroGlobal + ' MDP', options: { color: '000000', align: 'l' } }
        ]);
        rows5.push([
            { text: this.titulosFichaTecnica.observaciones, options: { color: '000000', bold: true, align: 'l' } },
            { text: obraSeleccionada.obra.observaciones, options: { color: '000000', align: 'l' } }
        ]);
        slide.addTable(rows5, { x: 0.1732283, y: 3.122047, w: 5.9094488, h: 1.917323, fontSize: 5, border: { pt: '1', color: 'bfbfbf' } });

        slide.addText(this.titulosFichaTecnica.problematica, { x: 0, y: 5.1220472, w: 6.0826772, h: 0.0984252, fontSize: 5, align: 'l', color: '000000', bold: true });
        slide.addText(obraSeleccionada.obra.problematica, { x: 0, y: 5.15748, w: 6.0826772, h: 0.2677165, fontSize: 5, align: 'l', color: '000000', autoFit: true, valign: 'top' });
        //END COL LEFT

        // COL RIGHT
        slide.addText('Fecha de actualización: ' + this.datepipe.transform(obraSeleccionada.obra.fechaActualizacion, 'yyyy-MM-dd'), { x: 5.4015748, y: 0.3267717, w: 4.5984252, h: 0.2007874, fontSize: 7, align: 'r', color: '000000', bold: true });
        slide.addImage({ data: this.mapaFichaTecnicaBase64, x: 6.1771654, y: 0.5944882, w: 3.724409, h: 2.385827 });

        slide.addText(this.titulosFichaTecnica.beneficios, { x: 6.1771654, y: 3.019685, w: 3.822835, h: 0.1, fontSize: 5, align: 'l', color: '000000', bold: true });
        slide.addText(obraSeleccionada.obra.beneficios, { x: 6.1771654, y: 3.082677, w: 3.822835, h: 1.110236, fontSize: 5, align: 'l', color: '000000', autoFit: true, valign: 'top' });

        slide.addText(this.titulosFichaTecnica.acciones, { x: 6.1771654, y: 4.3622047, w: 3.822835, h: 0.1, fontSize: 5, align: 'l', color: '000000', bold: true });
        slide.addText(obraSeleccionada.obra.proximasAcciones, { x: 6.1771654, y: 4.4606299, w: 3.822835, h: 0.9094488, fontSize: 5, align: 'l', color: '000000', autoFit: true, valign: 'top' });
        // slide.addImage({ data: this.validacionUCL, x: 0.1889764, y: 5.3661417, w: 9.6259843, h: 0.1496063 });
        //END COL RIGHT

        pptx.save('FichaTecnica-' + obraSeleccionada.nombreObra);
    }


    public descargarPowerPointNotaInformativa(obraSeleccionada: ObraDTO) {
        this.obtenerBase64ImageNotaInformativa().then(
            () => {
                this.generarPowerPointNotaInformativa(obraSeleccionada);
            }
        );
    }

    public async obtenerBase64ImageNotaInformativa(): Promise<any> {
        this.loaderScreenService.activarLoaderScreen();
        let configuracionCanvas = {
            // Opciones
            allowTaint: true,
            useCORS: true,
            // Calidad del PDF
            scale: 5,
            ignoreElements: function (element) {
                return element.classList.contains('gm-style-mtc') ? true : false;
            }
        };
        return new Promise((resolve, reject) => {
            html2canvas(document.getElementById('contenedor-mapa'), configuracionCanvas)
                .then(mapaFichaTecnica => {
                    let imgMapa = mapaFichaTecnica.toDataURL('image/jpeg', 1.0);
                    this.mapaNotaInformaticaBase64 = imgMapa;
                    this.loaderScreenService.desactivarLoaderScreen();
                    resolve();
                })
                .catch(error => {
                    console.error("Error al generar pdf: ", error);
                    reject();
                });
        });
    }

    public generarPowerPointNotaInformativa(obraSeleccionada: ObraDTO) {
        var pptx = new PptxGenJS();

        var slide = pptx.addNewSlide();
        // HEADER
        slide.addImage({ path: '../../../../../assets/img/logopng.png', x: 0, y: 0, w: 2.141732, h: 0.354331 });
        slide.addText(this.titulosNotaInformativa.titulo, { x: 0, y: 0.2519685, w: '100%', h: 0.2007874, fontSize: 8, align: 'c', color: '000000', bold: true });

        slide.addText(this.titulosNotaInformativa.asunto, { x: 0.1299213, y: 0.507874, w: 4.5984252, h: 0.0984252, fontSize: 6, align: 'l', color: '000000', bold: true });
        slide.addText(obraSeleccionada.nombreObra + ' - ' + obraSeleccionada.nombreEstado, { x: 0.4606299, y: 0.507874, w: 9.5393701, h: 0.0984252, fontSize: 6, align: 'l', color: '000000', autoFit: true });

        slide.addText(this.titulosNotaInformativa.descripcion, { x: 0.1299213, y: 0.6614173, w: 4.5984252, h: 0.0984252, fontSize: 6, align: 'l', color: '000000', bold: true });
        slide.addText(obraSeleccionada.obra.caracteristicas, { x: 0.6574803, y: 0.6181102, w: 9.3425197, h: 0.3385827, fontSize: 6, align: 'l', color: '000000', autoFit: true, valign: 'top' });

        slide.addText(this.titulosNotaInformativa.costoTotal, { x: 0.1299213, y: 1, w: 4.5984252, h: 0.0984252, fontSize: 6, align: 'l', color: '000000', bold: true });
        slide.addText(obraSeleccionada.obra.inversionTotal + ' MDP', { x: 0.5984252, y: 1, w: 1.519685, h: 0.0984252, fontSize: 6, align: 'l', color: '000000', autoFit: true });

        slide.addText(this.titulosNotaInformativa.metaTotal, { x: 0.1299213, y: 1.149606, w: 4.5984252, h: 0.0984252, fontSize: 6, align: 'l', color: '000000', bold: true });
        slide.addText(obraSeleccionada.obra.longitudTotal + ' KM', { x: 0.5984252, y: 1.149606, w: 1.519685, h: 0.0984252, fontSize: 6, align: 'l', color: '000000', autoFit: true });

        var rows5 = [];
        rows5.push([
            { text: '• ' + this.titulosNotaInformativa.TDPA, options: { color: '000000', bold: true, align: 'l' } },
            { text: obraSeleccionada.obra.tpda + ' Veh/día.', options: { color: '000000', align: 'l' } }
        ]);
        rows5.push([
            { text: '• ' + this.titulosNotaInformativa.registro, options: { color: '000000', bold: true, align: 'l' } },
            { text: obraSeleccionada.obra.registroSHCP, options: { color: '000000', align: 'l' } }
        ]);
        rows5.push([
            { text: '• ' + this.titulosNotaInformativa.proyecto, options: { color: '000000', bold: true, align: 'l' } },
            { text: obraSeleccionada.obra.proyectoEjecutivo + ' %', options: { color: '000000', align: 'l' } }
        ]);
        rows5.push([
            { text: '• ' + this.titulosNotaInformativa.derechoVia, options: { color: '000000', bold: true, align: 'l' } },
            { text: obraSeleccionada.obra.liberacionDerechoVia + ' %', options: { color: '000000', align: 'l' } }
        ]);
        rows5.push([
            { text: '• ' + this.titulosNotaInformativa.MIA, options: { color: '000000', bold: true, align: 'l' } },
            { text: obraSeleccionada.obra.mia + ' %', options: { color: '000000', align: 'l' } }
        ]);
        rows5.push([
            { text: '• ' + this.titulosNotaInformativa.CUS, options: { color: '000000', bold: true, align: 'l' } },
            { text: obraSeleccionada.obra.cus + ' %', options: { color: '000000', align: 'l' } }
        ]);
        slide.addTable(rows5, { x: 0.2125984, y: 1.287402, w: 2.141732, h: 1.098425, fontSize: 6, border: { pt: '0', color: 'ffffff' } });


        slide.addText(this.titulosNotaInformativa.situacion, { x: 0.09448819, y: 2.3622, w: 1.129921, h: 0.2007874, fontSize: 5, align: 'c', color: '000000', bold: true });
        var rows3 = [];
        rows3.push([
            { text: 'EJERCICIO FISCAL', options: { color: '000000', bold: true, align: 'c', fill: 'D9D9D9' } },
            { text: 'ASIGNACIÓN (mdp)', options: { color: '000000', bold: true, align: 'c', fill: 'D9D9D9' } },
            { text: 'META (km - estructura)', options: { color: '000000', bold: true, align: 'c', fill: 'D9D9D9' } }
        ]);
        var someArray = obraSeleccionada.obra.ejerciciosFiscales;
        for (var item of someArray) {
            rows3.push([
                { text: item.esquemaFiscal, options: { color: '000000', align: 'c' } },
                { text: item.asignacion, options: { color: '000000', align: 'c' } },
                { text: item.meta, options: { color: '000000', align: 'c' } }
            ]);
        }
        slide.addTable(rows3, { x: 0.2125984, y: 2.53937, w: '40%', fontSize: 4, border: { pt: '1', color: 'bfbfbf' } });

        slide.addText(this.titulosNotaInformativa.avances, { x: 0.1299213, y: 3.291339, w: 4.5984252, h: 0.0984252, fontSize: 6, align: 'l', color: '000000', bold: true });
        slide.addText('• ' + this.titulosNotaInformativa.avanceFisicoGlobal + ' ' + obraSeleccionada.obra.avanceFisicoGlobal + ' KM', { x: 0.1299213, y: 3.34646, w: 1.755906, h: 0.2007874, fontSize: 6, align: 'l', color: '000000', autoFit: true, valign: 'top' });
        slide.addText('• ' + this.titulosNotaInformativa.avanceFinancieroGlobal + ' ' + obraSeleccionada.obra.avanceFinancieroGlobal + ' KM', { x: 0.1299213, y: 3.448819, w: 1.755906, h: 0.2007874, fontSize: 6, align: 'l', color: '000000', autoFit: true, valign: 'top' });

        slide.addText(this.titulosNotaInformativa.problematica, { x: 0.1299213, y: 3.677165, w: 4.5984252, h: 0.0984252, fontSize: 6, align: 'l', color: '000000', bold: true });
        slide.addText(obraSeleccionada.obra.problematica, { x: 0.1299213, y: 3.775591, w: 9.8937008, h: 1.110236, fontSize: 6, align: 'l', color: '000000', autoFit: true, valign: 'top' });

        slide.addText(this.titulosNotaInformativa.acciones, { x: 0.1299213, y: 4.3385827, w: 4.5984252, h: 0.0984252, fontSize: 6, align: 'l', color: '000000', bold: true });
        slide.addText(obraSeleccionada.obra.proximasAcciones, { x: 0.1299213, y: 4.409449, w: 9.8937008, h: 1.110236, fontSize: 6, align: 'l', color: '000000', autoFit: true, valign: 'top' });

        slide.addText('Ciudad de México, a ' + this.datepipe.transform(obraSeleccionada.obra.fechaActualizacion, 'yyyy-MM-dd'), { x: 5.4015748, y: 5.0472441, w: 4.5984252, h: 0.2007874, fontSize: 7, align: 'r', color: '000000', bold: true });
        slide.addImage({ path: '../../../../../assets/img/footer-nota-informativa.jpg', x: 0, y: 5.2598425, w: 10, h: 0.3661417 });

        // Pagina Mapa
        var slideMapa = pptx.addNewSlide();
        slideMapa.addImage({ path: '../../../../../assets/img/logopng.png', x: 0, y: 0, w: 2.748031, h: 0.5 });
        slideMapa.addText(this.titulosNotaInformativa.tituloMapa, { x: 0, y: 0.515748, w: 10, h: 0.2007874, fontSize: 10, align: 'c', color: '000000', bold: true });
        slideMapa.addImage({ data: this.mapaNotaInformaticaBase64, x: 0.6653543, y: 0.9330709, w: 8.6692913, h: 4.0787402 });
        slideMapa.addImage({ path: '../../../../../assets/img/footer-nota-informativa.jpg', x: 0, y: 5.2598425, w: 10, h: 0.3661417 });

        pptx.save('NotaInformativa-' + obraSeleccionada.nombreObra);
    }

}
